module.exports = __webpack_public_path__ + "static/media/Illus-EmployeeFork@2x.cb844749.png";